"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useOverflowDivider", {
    enumerable: true,
    get: function() {
        return useOverflowDivider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _overflowContext = require("./overflowContext");
function useOverflowDivider(groupId) {
    const ref = _react.useRef(null);
    const registerDivider = (0, _overflowContext.useOverflowContext)((v)=>v.registerDivider);
    (0, _reactutilities.useIsomorphicLayoutEffect)(()=>{
        if (ref.current && groupId) {
            return registerDivider({
                element: ref.current,
                groupId
            });
        }
    }, [
        registerDivider,
        groupId
    ]);
    return ref;
}
